import React, { useEffect, useState, useContext } from 'react'
import { getImages } from '../components/Common/const'
import RangeSlider from "react-range-slider-input";
import "react-range-slider-input/dist/style.css";
import Slider from "react-slick";
import ModalLayout from '../components/Common/ModalLayout';
import SelectFilterModal from '../components/Srp/SelectFilterModal';
import { VehicleContext } from '../components/Context/VehicleContext';
import SrpLeft from '../components/Srp/SrpLeft';
import SearchComponent from '../components/Srp/SearchComponent';
import { useLocation } from 'react-router-dom';


const Srp = () => {
    const { getVehicleData, vehicleData, filteredVehicleData, searchText, setSearchText, numberFormatter, currentFilterData, setCurrentFilterData, activeFilter, setActiveFilter, priceFilterData, setPriceFilterData, mileageFilterData, setMileageFilterData, locationFilters, setLocationFilters } = useContext(VehicleContext);

    const [isSticky, setIsSticky] = useState(false);
    //const [srpFilter, setSrpFilter] = useState(false);
    //const [pageSize, setPageSize] = useState(50);
    const [isDataLoaded, setIsDataLoaded] = useState(true);
    const [isOpacity, setIsOpacity] = useState(true);

    const [value, setValue] = useState([priceFilterData.min, priceFilterData.max]);

    const handleInputChange = (index, event) => {
        let newValue = Number(event.target.value);
        if (!isNaN(newValue)) {
            const updatedValues = [...value];

            if (index === 0) {
                updatedValues[0] = newValue;
                if (newValue > updatedValues[1]) {
                    updatedValues[1] = newValue;
                }
            } else {
                updatedValues[1] = Math.max(newValue, updatedValues[0]);
            }
            setValue(updatedValues);
        }
    };

    const handlePriceSliderChange = (newValue) => {
        setPriceFilterData({ ...priceFilterData, ['current_min']: newValue[0], ['current_max']: newValue[1] });
    };

    const handleMileageSliderChange = (newValue) => {
        setMileageFilterData({ ...mileageFilterData, ['current_min']: newValue[0], ['current_max']: newValue[1] });
    };
    const [mobFilter, setMobFilter] = useState(false);
    const handleFilterBtn = () => {
        setMobFilter(!mobFilter)
    }
    const handleCloseFilter = () => {
        setMobFilter(false)
    }
    var srpCarSlider = {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: true,
        dots: true,
        pauseOnHover: false,
    };


    useEffect(() => {
        if (filteredVehicleData) {
            setIsDataLoaded(false);
            setTimeout(() => {
                setIsOpacity(false);
            }, 100);
        }
        //console.log("filtered vehicle data", filteredVehicleData);
        //console.log("current filters",currentFilterData);
    }, [filteredVehicleData]);



    useEffect(() => {
        // console.log("srp useEffect");

        getVehicleData();

        const handleScroll = () => {
            const topSection = document.getElementById('srpFilter');
            if (topSection) {
                const topSectionRect = topSection.getBoundingClientRect();
                const isTopSectionVisible = topSectionRect.top <= 0;
                setIsSticky(isTopSectionVisible);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {

        const handleScroll = () => {
            const topSection = document.getElementById('srpFilter');
            if (topSection) {
                const topSectionRect = topSection.getBoundingClientRect();
                const isTopSectionVisible = topSectionRect.top <= 0;
                setIsSticky(isTopSectionVisible);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    const [openFilterModal, setOpenFilterModal] = useState(false);

    const [filterData, setFilterData] = useState([]);

    const handleFilterModal = (field) => {
        setOpenFilterModal(true);

        setFilterData(currentFilterData[field]);
        setActiveFilter(field);
    };
    const closeMakeModal = () => {
        setOpenFilterModal(false)
    }

    const updateFilter = (filter_data) => {
        setCurrentFilterData({ ...currentFilterData, [activeFilter]: filter_data });
    }

    const clearFilter = (field) => {
        console.log(field);
        console.log(currentFilterData[field]);

        const filter_data = [];

        if (currentFilterData[field]) currentFilterData[field].forEach((v) => {
            filter_data.push({ ...v, isSelected: false })
        });

        setCurrentFilterData({ ...currentFilterData, [field]: filter_data });
    }

    const clearAllFilters = () => {
        clearFilter('year');
        clearFilter('make');
        clearFilter('model');
        clearFilter('trim');
        clearFilter('body_style');

        handlePriceSliderChange([priceFilterData.min, priceFilterData.max]);
        handleMileageSliderChange([mileageFilterData.min, mileageFilterData.max]);

        const filter_data = {};

        Object.keys(currentFilterData).map((field) => {
            filter_data[field] = [];
            currentFilterData[field].forEach((v) => {
                filter_data[field].push({ ...v, isSelected: false })
            });
        });

        setCurrentFilterData(filter_data);

        setLocationFilters(["Boerne, TX", "Austin, TX"]);
    }

    const openVDP = (vdp_url) => {
        window.location.href = "/vehicle-details/" + vdp_url;
    }




    const queryParameters = new URLSearchParams(window.location.search);
    const vehicleMake = queryParameters.get("make");

    useEffect(() => {

        clearAllFilters();

        if (vehicleMake) {

            const filter_data = currentFilterData.make.map((v, i) => {
                return v.name.toLowerCase() == vehicleMake.toLowerCase() ? { ...v, "isSelected": true } : v;
            });

            setCurrentFilterData({ ...currentFilterData, ["make"]: filter_data });

        }

        console.log("make test", vehicleMake, currentFilterData);

    }, [vehicleMake, vehicleData]);

    const location = useLocation();

    useEffect(() => {
        const preselected = location.state?.preselectedLocation;

        if (preselected) {
            setLocationFilters([preselected]);
        }
    }, [location.state?.preselectedLocation]);


    const [isSlMobile, setIsSlMobile] = useState(false);
    const handleSlResize = () => {
        setIsSlMobile(window.innerWidth < 768);
    };
    useEffect(() => {
        handleSlResize();
        window.addEventListener('resize', handleSlResize);
        return () => {
            window.removeEventListener('resize', handleSlResize);
        };
    }, []);
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const handleMouseEnter = (index) => {
        setHoveredIndex(index);
    };
    const handleMouseLeave = () => {
        setHoveredIndex(null);
    };

    // Sort By data 
    const [sortColumn, setSortColumn] = useState('utc_inventory_date');
    const [sortSelectValue, setSortSelectValue] = useState('utc_inventory_date');
    const [sortOrder, setSortOrder] = useState(1);
    const handleSortByChange = (e) => {
        const sort_val = e.target.value;
        setSortSelectValue(sort_val);
        setSortOrder(sort_val.includes("_low") ? -1 : 1);
        setSortColumn(sort_val.replace("_low",""));

        console.log(sort_val,sort_val.includes("_low") ? -1 : 1)
    };
    return (
        <>
            {/* {console.log("filteredVehicleData", filteredVehicleData)} */}
            {/*
            {console.log("filteredData", filteredData)} */}
            <section className='srp-wrap'>
                <div className='container'>
                    <div className='srp-flex d-flex'>
                        <SrpLeft
                            mobFilter={mobFilter}
                            handleCloseFilter={handleCloseFilter}
                            handlePriceSliderChange={handlePriceSliderChange}
                            handleMileageSliderChange={handleMileageSliderChange}
                            value={value}
                            handleInputChange={handleInputChange}
                            handleFilterModal={handleFilterModal}
                            filteredVehicleData={filteredVehicleData}
                            numberFormatter={numberFormatter}
                            currentFilterData={currentFilterData}
                            priceFilterData={priceFilterData}
                            mileageFilterData={mileageFilterData}
                            clearAllFilters={clearAllFilters}
                            locationFilters={locationFilters}
                            setLocationFilters={setLocationFilters}
                            clearFilter={clearFilter}
                        />
                        <div className='srp-right'>
                            <div className='d-flex align-items-center srp-title-flex justify-content-between'>
                                <div className='srp-title text-uppercase mb-3'>Search Results</div>
                                <div className='d-lg-none'>
                                    <button type='button' className='filter-btn' onClick={handleFilterBtn}>
                                        Filters <img src={getImages('filter-icon.svg')} alt='icon' />
                                    </button>
                                </div>
                            </div>

                            <SearchComponent filteredVehicleData={filteredVehicleData} searchText={searchText} setSearchText={setSearchText} openVDP={openVDP} />
                            <div className='d-flex align-items-center justify-content-between selected-filter-flex'>
                                <div className='d-none d-lg-block selected-items'>
                                    <div className='d-flex align-items-center flex-wrap'>
                                        {filteredVehicleData && <div className='sm-title fw-700 me-4 mb-2'>{filteredVehicleData.length} Results</div>}
                                        <div className='tags-group d-flex align-items-center'>
                                            {locationFilters.map((item, index) =>
                                                <div className='tag-btn me-2 mb-1' key={index}>{item}
                                                    <img
                                                        src={getImages('close-anticon.svg')}
                                                        alt="Remove"
                                                        onClick={() => {
                                                            clearFilter(item);

                                                            setLocationFilters(locationFilters.filter((location) => location !== item));
                                                        }}
                                                        style={{ cursor: "pointer" }}
                                                    />
                                                </div>
                                            )}
                                            {(priceFilterData.current_min > priceFilterData.min || priceFilterData.current_max < priceFilterData.max) && <div className='tag-btn me-2 mb-1'>Price {priceFilterData.current_min == priceFilterData.min ? "Min" : numberFormatter(priceFilterData.current_min, true)} - {priceFilterData.current_max == priceFilterData.max ? "Max" : numberFormatter(priceFilterData.current_max, true)} <img src={getImages('close-anticon.svg')} onClick={() => { handlePriceSliderChange([priceFilterData.min, priceFilterData.max]) }} /></div>}
                                            {(mileageFilterData.current_min > mileageFilterData.min || mileageFilterData.current_max < mileageFilterData.max) && <div className='tag-btn me-2 mb-1'>Mileage {mileageFilterData.current_min == mileageFilterData.min ? "Min" : numberFormatter(mileageFilterData.current_min)} - {mileageFilterData.current_max == mileageFilterData.max ? "Max" : numberFormatter(mileageFilterData.current_max)} <img src={getImages('close-anticon.svg')} onClick={() => { handleMileageSliderChange([mileageFilterData.min, mileageFilterData.max]) }} /></div>}
                                            {Object.keys(currentFilterData).filter((index) => currentFilterData[index].some(item => item.isSelected) > 0).map((item, index) =>
                                                <div className='tag-btn me-2 mb-1' key={index}>{item}
                                                    <img
                                                        src={getImages('close-anticon.svg')}
                                                        alt="Remove"
                                                        onClick={() => {
                                                            clearFilter(item);
                                                        }}
                                                        style={{ cursor: "pointer" }}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className='d-lg-flex align-items-center justify-content-end sort-by-col'>
                                    <div className='xxs-title text-nowrap font-0-9em me-3'>Sort by</div>
                                    <select className='form-control sort-select-field'
                                        value={sortSelectValue}
                                        onChange={handleSortByChange}
                                    >
                                        <option value="utc_inventory_date">Newest Inventory</option>
                                        <option value="price">Price: High to Low</option>
                                        <option value="price_low">Price: Low to High</option>
                                        <option value="mileage">Miles: High to Low</option>
                                        <option value="mileage_low">Miles: Low to High</option>
                                    </select>
                                </div>
                            </div>
                            <div className='row mt-4'>
                                {filteredVehicleData &&
                                    filteredVehicleData.sort((a,b) => (b[sortColumn] - a[sortColumn]) * sortOrder).map((item, index) => (
                                        <div className='col-xl-4 col-sm-6 col-12 wow fadeIn' data-wow-duration="0.5s" data-wow-delay={`0.2s`} key={index}>
                                            <div className='srp-box'
                                                onMouseEnter={() => handleMouseEnter(index)}
                                                onMouseLeave={handleMouseLeave}
                                            >
                                                <div className='srp-top'>
                                                    {item.images.length > 0 ?
                                                        <>
                                                            {(item.images.length > 2 && (isSlMobile || hoveredIndex === index)) ? (
                                                                <Slider className='srp-slider' {...srpCarSlider} >
                                                                    {item.images && item.images.map((photo, j) => {
                                                                        if (j > 2) return false;
                                                                        return (
                                                                            <div onClick={() => openVDP(item.vdp_url ?? "used-" + item.vin)} key={"vdp" + j}>
                                                                                <div className='inner'>
                                                                                    <img src={photo} alt={`${item.year} ${item.make} ${item.model}`} onError={(e) => { e.target.src = getImages("unavailable_stockphoto.avif") }} />
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    })}
                                                                </Slider>
                                                            )
                                                                :
                                                                <div style={{cursor:'pointer'}} onClick={() => openVDP(item.vdp_url ?? "used-" + item.vin)} key={"vdp" + index}>
                                                                    <img src={item.images && item.images[0]} onError={(e) => { e.target.src = getImages("unavailable_stockphoto.avif") }} />
                                                                </div>
                                                            }
                                                        </>
                                                        :
                                                        <div style={{cursor:'pointer'}} onClick={() => openVDP(item.vdp_url ?? "used-" + item.vin)} key={"vdp" + index}>
                                                            <img src={getImages('srp_coming_soon.webp')} alt='' />
                                                        </div>
                                                    }
                                                </div>
                                                <div className='srp-bottom'>
                                                    <div className='sm-title text-theme fw-700 mb-2 mt-2 srpt-title'>{item.year} {item.make} {item.model}</div>
                                                    <div className='xs-title font-0-9em fw-400 mb-2 srpt-desc'>{item.desc}</div>
                                                    <div className='d-flex align-items-center justify-content-between'>
                                                        <div className='d-flex align-items-center'>
                                                            {item?.carColors?.length > 0 && (
                                                                <div className='position-relative sr-color-block me-3'>
                                                                    {item.carColors.map((colorItem, colorIndex) => (
                                                                        <span
                                                                            key={colorIndex}
                                                                            className="sr-color"
                                                                            style={{ background: colorItem }}
                                                                        ></span>
                                                                    ))}
                                                                </div>
                                                            )}
                                                            <div className='sm-title opacity-0-7'>{numberFormatter(item.mileage)}</div>
                                                        </div>
                                                        <div className='srp-price'>{numberFormatter(item.price, true)}</div>
                                                    </div>
                                                    <div className='mt-2'>
                                                        <button className='btn-black-theme w-100' type='button' onClick={() => openVDP(item.vdp_url ?? "used-" + item.vin)}>View</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {openFilterModal &&
                <ModalLayout open={openFilterModal} close={closeMakeModal} darkThemeCls='true' modalWidth={970}>
                    <SelectFilterModal
                        close={closeMakeModal}
                        filterData={filterData}
                        updateFilter={updateFilter}
                        activeFilter={activeFilter}
                    />
                </ModalLayout>
            }
        </>
    )
}

export default Srp